;(function() {
  var optionSelector = '.wk_extend_warr_div';
  var activeClass = 'wk_active_block';
  var warrantyInputSelector = 'input.main_id_variant';
  var productFormSelector = 'form[action="/cart/add"], form[action^="/cart/add"]';
  var submittingClass = 'btn--loading';
  var termSelector = optionSelector + ' > p.font-400';
  var errorClass = 'wk_warr_err--visible';
  var duplicateWarrantyMessage = 'A warranty product already exists in your cart and cannot be added again.';
  var warrantyProductHandle = 'warranty-product';
  var drawerQuantitySelector = '.hs-item-cart-content-quantity';
  var drawerQuantityHiddenClass = 'wk-hide-warranty-quantity';
  var cartSyncTimer = null;
  var cartSyncInProgress = false;

  function formatWarrantyTerm(term) {
    if (!term || term.querySelector('.wk-warranty-term')) return;

    var text = term.textContent.replace(/^\s*\+\s*/, '').trim();
    if (!text) return;

    term.textContent = '';

    var wrapper = document.createElement('span');
    wrapper.className = 'wk-warranty-term';

    var plus = document.createElement('span');
    plus.className = 'wk-warranty-plus';
    plus.textContent = '+';

    var termText = document.createElement('span');
    termText.className = 'wk-warranty-term-text';
    termText.textContent = text;

    wrapper.appendChild(plus);
    wrapper.appendChild(termText);
    term.appendChild(wrapper);
  }

  function formatWarrantyTerms(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(termSelector).forEach(formatWarrantyTerm);
  }

  function observeWarrantyTerms() {
    if (!window.MutationObserver) return;

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;

          if (node.matches && node.matches(termSelector)) {
            formatWarrantyTerm(node);
            return;
          }

          formatWarrantyTerms(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function toggleActiveOption(option) {
    var group = option.closest('.wk_extend_all_warranty');
    if (!group) return;
    hideWarrantyError(group);

    var shouldDeactivate = option.classList.contains(activeClass);

    group.querySelectorAll(optionSelector + '.' + activeClass).forEach(function(activeOption) {
      activeOption.classList.remove(activeClass);
    });

    if (!shouldDeactivate) {
      option.classList.add(activeClass);
    }
  }

  function getQuantity(form) {
    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function getMainVariantId(form) {
    var variantInput = form.querySelector('[name="id"]');
    return variantInput ? variantInput.value : '';
  }

  function getActiveWarrantyOption(form) {
    var scope = form.closest('[data-section-type="product"], .product-section, .product-single__meta, main');
    var activeOption = scope ? scope.querySelector(optionSelector + '.' + activeClass) : null;

    return activeOption || document.querySelector(optionSelector + '.' + activeClass);
  }

  function getWarrantyVariantId(option) {
    var variantInput = option ? option.querySelector(warrantyInputSelector) : null;
    return variantInput ? variantInput.value : '';
  }

  function getWarrantyVariantIds() {
    return Array.from(document.querySelectorAll(optionSelector + ' ' + warrantyInputSelector))
      .map(function(input) {
        return input.value;
      })
      .filter(Boolean);
  }

  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function(response) {
      return response.json();
    });
  }

  function cartHasWarranty(cart) {
    var warrantyVariantIds = getWarrantyVariantIds();
    if (!cart || !Array.isArray(cart.items)) return false;

    return cart.items.some(function(item) {
      return item.handle === warrantyProductHandle || warrantyVariantIds.indexOf(String(item.variant_id)) !== -1;
    });
  }

  function getWarrantyCartLines(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];

    return cart.items
      .map(function(item, index) {
        return {
          item: item,
          line: index + 1
        };
      })
      .filter(function(lineItem) {
        return lineItem.item.handle === warrantyProductHandle;
      });
  }

  function updateCartLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity
      })
    }).then(function(response) {
      return response.json();
    });
  }

  function normalizeWarrantyCart(cart) {
    var warrantyLines = getWarrantyCartLines(cart);
    var updates = [];

    if (!warrantyLines.length) return Promise.resolve(cart);

    warrantyLines.slice().reverse().forEach(function(lineItem) {
      if (lineItem.line !== warrantyLines[0].line) {
        updates.push(function() {
          return updateCartLine(lineItem.line, 0);
        });
      }
    });

    if (warrantyLines[0].item.quantity > 1) {
      updates.push(function() {
        return updateCartLine(warrantyLines[0].line, 1);
      });
    }

    return updates.reduce(function(promise, update) {
      return promise.then(update);
    }, Promise.resolve(cart));
  }

  function hideWarrantyDrawerQuantities(cart) {
    var quantityEls = Array.from(document.querySelectorAll(drawerQuantitySelector));
    if (!quantityEls.length) return;

    quantityEls.forEach(function(quantityEl) {
      quantityEl.classList.remove(drawerQuantityHiddenClass);
    });

    if (!cart || !Array.isArray(cart.items)) return;

    cart.items.forEach(function(item, index) {
      if (item.handle !== warrantyProductHandle || !quantityEls[index]) return;

      quantityEls[index].classList.add(drawerQuantityHiddenClass);
    });
  }

  function syncWarrantyDrawerCart() {
    if (cartSyncInProgress) return;

    cartSyncInProgress = true;
    getCart()
      .then(function(cart) {
        hideWarrantyDrawerQuantities(cart);
        return normalizeWarrantyCart(cart);
      })
      .then(function(cart) {
        hideWarrantyDrawerQuantities(cart);
      })
      .catch(function(error) {
        console.warn('Warranty cart sync failed', error);
      })
      .finally(function() {
        cartSyncInProgress = false;
      });
  }

  function scheduleWarrantyDrawerCartSync() {
    clearTimeout(cartSyncTimer);
    cartSyncTimer = setTimeout(syncWarrantyDrawerCart, 120);
  }

  function observeWarrantyDrawerCart() {
    if (!window.MutationObserver) return;

    var observer = new MutationObserver(function(mutations) {
      var shouldSync = mutations.some(function(mutation) {
        return Array.from(mutation.addedNodes).some(function(node) {
          return node.nodeType === 1 && (
            node.matches && node.matches(drawerQuantitySelector) ||
            node.querySelector && node.querySelector(drawerQuantitySelector)
          );
        });
      });

      if (shouldSync) {
        scheduleWarrantyDrawerCartSync();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function getWarrantyContainer(target) {
    if (target && target.classList && target.classList.contains('wk_main_extend_warranty')) {
      return target;
    }

    var closest = target && target.closest ? target.closest('.wk_main_extend_warranty') : null;
    if (closest) return closest;

    var scope = target && target.closest ? target.closest('[data-section-type="product"], .product-section, .product-single__meta, main') : document;
    return scope.querySelector('.wk_main_extend_warranty') || document.querySelector('.wk_main_extend_warranty');
  }

  function getWarrantyError(container) {
    if (!container) return null;

    var error = container.querySelector('.wk_warr_err');
    if (error) return error;

    error = document.createElement('div');
    error.className = 'wk_warr_err';
    container.appendChild(error);

    return error;
  }

  function showWarrantyError(target, message) {
    var container = getWarrantyContainer(target);
    var error = getWarrantyError(container);
    if (!error) return;

    error.textContent = message || duplicateWarrantyMessage;
    error.classList.add(errorClass);
  }

  function hideWarrantyError(target) {
    var container = getWarrantyContainer(target || document);
    var error = container ? container.querySelector('.wk_warr_err') : null;
    if (!error) return;

    error.classList.remove(errorClass);
  }

  function addItemsToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items
      })
    }).then(function(response) {
      return response.json().then(function(data) {
        if (!response.ok) {
          throw data;
        }

        return data;
      });
    });
  }

  function addSelectedWarrantyToCart(event, addToCartButton) {
    var form = addToCartButton.closest(productFormSelector);
    if (!form || form.dataset.warrantySubmitting === 'true') return;

    var activeOption = getActiveWarrantyOption(form);
    var warrantyVariantId = getWarrantyVariantId(activeOption);
    if (!warrantyVariantId) return;

    var mainVariantId = getMainVariantId(form);
    if (!mainVariantId) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var quantity = getQuantity(form);

    form.dataset.warrantySubmitting = 'true';
    if (addToCartButton) {
      addToCartButton.classList.add(submittingClass);
    }

    var finishCartOperation = window.theme && theme.cart && theme.cart.beginAddOperation
      ? theme.cart.beginAddOperation('warranty-add') : null;
    var succeeded = false;

    getCart()
      .then(function(cart) {
        var items = [
          {
            id: mainVariantId,
            quantity: quantity
          }
        ];

        if (cartHasWarranty(cart)) {
          showWarrantyError(form, duplicateWarrantyMessage);
        } else {
          hideWarrantyError(form);
          items.push({
            id: warrantyVariantId,
            quantity: quantity
          });
        }

        return addItemsToCart(items);
      })
      .then(function(data) {
        document.dispatchEvent(new CustomEvent('globo.preorder.update.cart'));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data,
            addToCartBtn: addToCartButton
          }
        }));
        scheduleWarrantyDrawerCartSync();
        succeeded = true;

        if (document.body.classList.contains('template-cart')) {
          window.scrollTo(0, 0);
          window.location.reload();
        }
      })
      .catch(function(error) {
        var message = error && (error.description || error.message) ? (error.description || error.message) : 'Unable to add warranty to cart.';
        window.alert(message);
      })
      .finally(function() {
        if (finishCartOperation) finishCartOperation(succeeded);
        delete form.dataset.warrantySubmitting;
        if (addToCartButton) {
          addToCartButton.classList.remove(submittingClass);
        }
      });
  }

  document.addEventListener('click', function(event) {
    var option = event.target.closest(optionSelector);
    if (option) {
      event.stopPropagation();
      toggleActiveOption(option);
      return;
    }

    var addToCartButton = event.target.closest('[data-add-to-cart]');
    if (!addToCartButton) return;
    if (addToCartButton.disabled || addToCartButton.getAttribute('aria-disabled') === 'true') return;

    addSelectedWarrantyToCart(event, addToCartButton);
  }, true);

  formatWarrantyTerms(document);
  observeWarrantyTerms();
  observeWarrantyDrawerCart();
  scheduleWarrantyDrawerCartSync();
})();
